/**
 * Append Azure SAS token from environment variables to a blob URL
 * @param {string} blobUrl - The base Azure blob URL without SAS token
 * @returns {string} - The complete URL with SAS token if available
 */
export const appendAzureSasToken = (blobUrl) => {
  if (!blobUrl) {
    return null;
  }

  const sasToken = process.env.REACT_APP_AZURE_SAS_TOKEN;

  if (!sasToken) {
    // If no SAS token in env, return the base URL
    // This might work if the container allows anonymous access
    console.warn('REACT_APP_AZURE_SAS_TOKEN not found in environment variables');
    return blobUrl;
  }

  // Avoid double appending if token is already in URL
  if (blobUrl.includes('?')) {
    return blobUrl;
  }

  // Append SAS token (add '?' prefix if not already present)
  const tokenPrefix = sasToken.startsWith('?') ? '' : '?';
  return `${blobUrl}${tokenPrefix}${sasToken}`;
};
